const routes = [
  // 工作台
  // {
  //   path: "/medical/home",
  //   name: "mHomePage",
  //   meta: {
  //     title: '工作台',
  //     hasBack: false
  //   },
  //   component: () => import("@/pages/medical/indexPage/indexPage.vue")
  // },
];

export default routes;
